import { Editor, type Path } from '@lumapps/wrex/slate';
import { findParent } from '@lumapps/wrex/slate/utils/findParent';

import { isColumn } from './isColumn';

/**
 * Checks whether the current selection is inside a column
 */
export const isSelectionInColumn = (editor: Editor, path?: Path): boolean => {
    const pathToCheck = path ?? editor.selection?.focus.path;

    // If we don't have a path, we can't check if we're in a column
    if (!pathToCheck) {
        return false;
    }

    const columnEntry = findParent(editor, pathToCheck, isColumn);
    return !!columnEntry;
};
